import { AppDispatchContext } from 'contexts/AppDispatchContext';
import { useContextStrict } from 'hooks/useContextStrict';

export const useAppDispatch = () => {
  return useContextStrict(AppDispatchContext);
};
